<template>
  <v-container fluid class="pa-0 ma-0"> <!-- uso de clases css class="componente-nombreClase"-->
  <v-row v-bind:class="{'smartbell-justifyAlign': userData.onboarding === false}">
    <!-- inicio barra lateral-->
    <v-col md="2" class="smartbell-smartbellLeftSideDesktop" v-if="userData.onboarding === true">
    </v-col>
    <!-- fin barra lateral-->

    <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">

      <!-- inicio perfil de usuario-->
      <v-row justify="center" class="UserPorifle-footer">
          <v-col cols="10" md="12" class="pt-0">

            <!-- inicio fila superior-->
            <v-row justify="space-between"
                   v-if="userData.onboarding === true"
                   class="pr-14">

              <!-- inicio de botón de agregar vaca -->
              <v-col cols="3" class="pa-0 pl-3">
                <v-btn class="pt-2 pb-1 smartbell-blueButton button-text d-flex justify-space-between align-center"
                style="align-items: center; justify-content: center;"
                block
                depressed
                elevation="6"
                height=40px
                @click="openPageUserAdd('userAdd')">
                  <div class="d-flex justify-space-between align-center button-text btn-text-container">
                    Agregar Usuario
                    <img class="d-flex align-center" src="../assets/icons/AddUser.png" alt="">
                  </div>
                </v-btn>
              </v-col>
              <!-- fin de botón de agregar vaca -->

              <!-- inicio de cambiar de rancho -->
              <v-col cols="3" class="pa-0">
                <ChangeRanch></ChangeRanch>
              </v-col>
              <!-- fin de cambiar de rancho -->

              <!-- inicio contador de ranchos-->
              <v-col cols="3" class="pa-0">
                <SystemCardCount height="40px"
                                 width="100%"
                                 number="100"
                                 title-background="#57A7F5"
                                 number-background="#1460AA"
                                 title="Usuarios en Sistema">
                </SystemCardCount>
              </v-col>
              <!-- fin contador de ranchos -->
            </v-row>
            <!-- fin fila superior-->

            <!-- inicio cuerpo principal-->
            <v-row justify="center">
              <v-col md="12" cols="12" class="pr-14">
                <v-card elevation="8">
                  <!-- inicio barra usuario-->
                  <v-col cols="12"
                  class="std-background-grey-3 pa-0 justify-center d-flex align-center"
                  style="height: 48px;">
                    <!-- inicio boton regresar-->
                    <v-row no-gutters style="position: absolute; left: 18px;">
                      <v-btn class="d-flex justify-space-around std-text-md"
                             style="font-weight: bold; font-family: 'Montserrat', sans-serif; text-transform: none;"
                             block
                             text
                             height="40px"
                             depressed
                             @click="openPage('UserProfile')">
                        <div class="d-flex justify-space-between align-center std-text-md std-text-white-1">
                          <i class="std-cow-icon std-back-icon pa-0 mr-2" style="filter: brightness(100);"></i>
                          Regresar
                        </div>
                      </v-btn>
                    </v-row>
                    <!-- fin boton regresar-->
                    <v-row class="d-flex col-4 justify-center std-text-lg std-text-white-1"
                    style="width: 100%; font-weight: bold; text-align: center">
                      Dueño
                    </v-row>
                  </v-col>
                  <!-- fin barra usuario-->
                  
                  <!-- inicio inputs-->
                  <v-row justify="center" class="pb-0 px-3">
                      <!-- inicio primera columna-->
                      <v-col cols=4>
                        <!-- inicio medidor plan-->
                        <v-row justify="center" class="pa-3 pb-0">
                            <v-col md="10"
                                   cols="12"
                                   class="pa-0 std-text-blue-2">
                              <h3 style="font-size: 1.25rem">
                                Plan Activo</h3>
                            </v-col>
                          </v-row>
                          <v-row justify="center" class="pa-3 pb-0">
                            <v-col md="10" cols="12" class="pa-0">
                              <v-progress-linear
                                :active="true"
                                :background-opacity=".3"
                                :rounded="true"
                                :value="95"
                                color="#FF006A"
                                style="width: 100%;"
                              ></v-progress-linear>
                              <p class="std-text-red-1 mt-2">
                                  Llevas <strong>45 vacas</strong> de 50</p>
                            </v-col>
                          </v-row>
                          <v-row justify="center" class="pa-3 pb-0">
                            <v-col md="10" cols="12" class="pa-0">
                              <v-btn  text
                                      width=100%
                                      class="std-container-shadow smartbell-greenButton smartbell-buttonCorrection"
                                      @click="openPageUserType('UserType')">
                                  Mejora tu Plan</v-btn>
                            </v-col>
                          </v-row>
                          <!-- fin medidor plan-->

                          <!-- inicio ficha plan-->
                          <v-row justify="center" class="pt-8 pa-3">
                            <v-col cols=10 class="pa-0">
                                <v-card>
                                    <v-card-title class="pa-0 px-4 std-background-blue-2 align-center justify-content"
                                    style="height: 40px;">
                                    <p class="std-text-white-1 ma-0"
                                    style="font-size: 1.75rem; text-align: center; width: 100%">
                                    Plan: Cría</p>
                                        
                                    </v-card-title>
                                    <v-card-text class="px-2 py-4">
                                        <p class="std-text-md std-text-gray-3 ma-0">
                                            • Hasta <b>50 vacas</b><br>
                                            • Alertas vía e-mail<br>
                                            • Soporte técnico en 72hrs<br>
                                            • <b>1 Usuario</b><br>
                                            • Bitácora<br>
                                            • Historial permanente
                                        </p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                          </v-row>
                          <!-- fin ficha plan-->

                          <v-row justify="center" class="pa-3 py-0">
                            <v-col md="10"
                                   cols="12"
                                   class="pa-0 std-text-blue-1">
                              <h3 class="std-text-sm std-text-underline"
                                  style="font-weight: 400; cursor: pointer;"
                                  @click="openPageAditionalModules('AditionalModules')">
                                Ver mis módulos adicionales</h3>
                            </v-col>
                          </v-row>
                      </v-col>
                      <!-- fin primera columna-->

                      <!-- inicio segunda columna-->
                      <v-col cols=8>
                          <v-row class="pa-3">
                              <!-- inicio datos izquierda-->
                              <v-col cols=5>
                                  <!-- inicio datos facturacion-->
                                  <v-row class="pl-3">
                                      <v-col cols=8
                                      class="pa-0 std-text-blue-2 std-text-sm">
                                          <v-row class="py-1">Facturación</v-row>
                                          <v-row class="py-1">Ultima fecha de pago</v-row>
                                          <v-row class="py-1">Fecha de renovación</v-row>
                                      </v-col>
                                      <v-col cols=4
                                      class="pa-0 std-text-blue-2 std-text-sm"
                                      style="font-weight: bold;">
                                          <v-row class="py-1">Mensual</v-row>
                                          <v-row class="py-1">dd/mm/aaaa</v-row>
                                          <v-row class="py-1">dd/mm/aaaa</v-row>
                                      </v-col>
                                  </v-row>
                                  <!-- fin datos facturacion-->

                                  <!-- inicio agregar usuario-->
                                  <v-row class="mt-4 align-center justify-center std-text-md std-text-gray-3 std-border-radius"
                                  style="border-style: solid; border-color: var(--smartbell-blue-3); height: 40px; border-width: 1px; cursor: pointer;">
                                    <img class="d-flex align-center pr-2"
                                         src="../assets/icons/AddUser.png" alt="">
                                    <div class="">Agregar usuario <b>$49</b></div> <div class="d-flex std-text-xss pl-1"> mxn/mes</div>
                                  </v-row>
                                  <!-- fin agregar usuario-->
                              </v-col>
                              <!-- fin datos izquierda-->

                              <!-- inicio datos derecha-->
                              <v-col cols=5 offset=1 class="pt-0">
                                <v-row class="pl-3 std-text-blue-2">
                                  <h3 style="font-size: 1.25rem">
                                    Métodos de pago</h3>
                                </v-row>
                                <v-row class="pl-3 py-2 std-text-sm std-text-gray-2 justify-space-between">
                                  <div class="d-flex">
                                    <img class="d-flex align-center pr-2"
                                         src="../assets/icons/Payment Methods/Mastercard.png" alt="">
                                    •••• •••• •••• 5689</div>
                                  <div>mm • aaaa</div>
                                </v-row>

                                <v-row class="pl-3 py-2 std-text-sm std-text-gray-2 justify-space-between">
                                  <div class="d-flex">
                                    <img class="d-flex align-center pr-2"
                                         src="../assets/icons/Payment Methods/Visa.png" alt="">
                                    •••• •••• •••• 3465</div>
                                  <div>mm • aaaa</div>
                                </v-row>

                                <v-row class="pl-3 py-4 std-text-sm std-text-gray-2 justify-end"
                                style="cursor: pointer;">
                                  <div class="d-flex align-center">
                                    <img class="d-flex align-center mr-2" style="width: 24px; height: 24px;"
                                         src="../assets/Icon_Add.png" alt="">
                                         Agregar metodo de pago
                                  </div>
                                </v-row>
                              </v-col>
                              <!-- fin datos derecha-->

                              <!-- inicio tabla-->
                              <v-col cols=12 class="pa-0 pr-14">
                                <v-row class="pa-3 std-text-blue-2 justify-space-between">
                                  <h3 style="font-size: 1.25rem">
                                    Mis Facturas</h3>

                                  <h3 class="std-text-sm std-text-underline std-text-blue-1"
                                      style="font-weight: 400; cursor: pointer;"
                                      @click="">
                                    Ver todas mis facturas</h3>
                                </v-row>

                                <!-- inicio de tabla -->
                                <v-row class="std-border-radius align-content-start justify-center"
                                no-gutters>
                                  <!-- inicio de contenedor de tabla -->
                                  <v-col cols="12" class="pa-0">
                                      <!-- inicio de contenedor de header -->
                                      <v-row no-gutters>
                                          <v-col cols="12"
                                                  class="std-table-header d-flex align-center justify-center std-text-md font-weight-bold">
                                              <div class=" col-5 d-flex justify-center align-center">
                                                  Descripción<i class="std-vertical-arrow-icon"></i>
                                              </div>
                                              <div class="col-3 d-flex justify-center align-center">
                                                  Monto<i class="std-vertical-arrow-icon"></i>
                                              </div>
                                              <div class="col-4 d-flex justify-center align-center">
                                                  Fecha de pago<i class="std-vertical-arrow-icon"></i>
                                              </div>
                                          </v-col>
                                      </v-row>
                                      <!-- fin de contenedor de header-->

                                      <!-- inicio contenido tabla -->
                                      <v-row no-gutters
                                              class="up-table-row-container pa-0"
                                              justify="center"
                                              align-content="start">
                                          <v-col cols="12"
                                                 class="d-flex align-center justify-center std-table-row-container std-text-md std-text-gray-3">
                                              <div class="col-5 d-flex align-center justify-center">
                                                Membresía “cría” - 50 vacas
                                              </div>
                                              <div class="col-3 d-flex align-center justify-center">
                                                $00,000.00
                                              </div>
                                              <div class="col-3 d-flex align-center justify-end">
                                                04/Nov/2017
                                              </div>
                                              <div class="col-1 d-flex align-center justify-center">
                                                <img src="../assets/Arrow_Right.svg" alt="">
                                              </div>
                                          </v-col>
                                      </v-row>
                                      <!-- fin contenido tabla -->
                                  </v-col>
                                  <!-- fin de contenedor de tabla -->
                                </v-row>
                                <!-- fin de tabla -->

                                <v-row class="justify-end">
                                  <v-dialog v-model="dialog" width=866>
                                    <template v-slot:activator="{ on }" class="align-center justify-center">
                                      <h3 v-on="on"
                                          class="pr-3 py-2 std-text-sm std-text-underline std-text-red-1"
                                          style="font-weight: 400; cursor: pointer;">
                                        Cancelar Membresía</h3>
                                    </template>
                                    <!-- inicio carta cancelar membresia-->
                                    <v-card style="border-style: solid; border-color: var(--smartbell-red-1); border-width: 2px">
                                      <v-row class="pa-3" no-gutters>
                                      <!-- inicio imagen vacas tristes-->
                                      <v-col cols=6 class="d-flex pa-2 align-center justify-center">
                                        <img src="../assets/cow-ilustrations/Sad_Cows.png" alt="">
                                      </v-col>
                                      <!-- fin imagen vacas tristes-->

                                      <!-- inicio contenido-->
                                      <v-col cols=6 class="pa-4 d-flex justify-center align-center flex-column">
                                        <v-row class="py-2 std-text-md std-text-blue-2 d-flex"
                                             style="text-align: center;">
                                          <div>¿Seguro quieres cancelar tu membresía?<br>Te vamos a extrañar!!!</div>
                                        </v-row>
                                        <v-row class="py-2 std-text-md std-text-red-1 d-flex"
                                             style="text-align: center;">
                                          <div><b>Al cancelar</b> tu membresía, tendrás hasta el <b>dd/mm/aaaa</b> para realizar la descarga de los datos de tus vacas.</div>
                                        </v-row>
                                        <v-row class="py-2 std-text-md std-text-blue-2 d-flex align-center justify-center"
                                             style="text-align: center; width: 100%;">
                                          Razon de cancelación
                                          <v-autocomplete
                                                  style="max-width: 240px;"
                                                  hide-details
                                                  dense
                                                  flat
                                                  placeholder="Dinos por que"
                                                  outlined
                                          ></v-autocomplete>
                                        </v-row>
                                        <v-row class="pt-6 d-flex align-center justify-center">
                                          <v-btn block
                                                   width=240px
                                                   style="background-color: var(--smartbell-red-1); width: 240px"
                                                   class="std-btn"
                                                   @click="saveAnimal()">
                                              Entendido</v-btn>
                                        </v-row>
                                        <v-row>

                                        </v-row>
                                      </v-col>
                                      <!-- fin contenido-->
                                    </v-row>
                                    </v-card>
                                    <!-- fin carta cancelar membresia-->
                                  </v-dialog>
                                </v-row>
                              </v-col>
                              <!-- inicio tabla-->
                          </v-row>
                      </v-col>
                      <!-- fin segunda columna-->
                  </v-row>
                  <!-- inicio inputs-->
                </v-card>
              </v-col>
            </v-row>
            <!-- fin cuerpo principal-->
          </v-col>
      </v-row>
      <!-- fin perfil de usuario-->

      <v-footer color="#F9FDFE" padless class="smartbell-footer">
          <v-row justify="center" no-gutters>
              <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Preguntas frecuentes</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Ayuda</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Precios</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Calcula tu eficiencia</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Aviso de privacidad</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Terminos y condiciones</v-btn>
              </v-col>
          </v-row>
      </v-footer>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
import NavBar from '@/views/NavBar.vue';
import { EventBus } from '@/views/bus.js';
import SystemCardCount from "../components/SystemCardCount";
import ChangeRanch from '@/components/ChangeRanch.vue';
export default {
  components: {
    NavBar,
    SystemCardCount,
    ChangeRanch
  },
  computed: {
    userData(){
      return this.$store.getters.getUserData
    },
  },
  methods: {
    openSectionOnboarding(section){
      if(this.section === 'DashHome'){
        this.editActive = true
        this.saveActive = false
        EventBus.$emit('openSectionOnboarding', section);
      }else{
         this.editActive = true
        this.saveActive = false
        EventBus.$emit('openSectionOnboarding', section);
      }
    },
    openPage() {
      this.$router.push({name: 'UserProfile'})
    },
    openPageUserType() {
      this.$router.push({name: 'UserType'})
    },
    openPageAditionalModules() {
      this.$router.push({name: 'AditionalModules'})
    },
    openPageUserAdd() {
      this.$router.push({name: 'UserAdd'})
    },
  },
  mounted () {
  }
};
</script>

<style lang="css">
  @import '../style/UserPlan.css';
</style>